import React, { useEffect, useId, useState } from 'react';
import { normalizeOtherOption, otherOptionLabel } from '../utils/listOtherOption';

/** Answers retain the existing string/string[] format across exports and workflows. */
export default function ListField({ field, value, onChange, disabled = false, className = '', options = field.options || [] }) {
  const inputId = useId();
  const optionValues = options.map(String);
  const answers = (Array.isArray(value) ? value : value ? [value] : []).map(String);
  const custom = answers.filter(answer => !optionValues.includes(answer));
  const customValue = custom[0] || '';
  const [editingOther, setEditingOther] = useState(custom.length > 0);
  const [draft, setDraft] = useState(custom[0] || '');
  // Preserve historical answers, including values no longer in the current list.
  useEffect(() => { if (customValue) { setEditingOther(true); setDraft(customValue); } }, [customValue]);
  const other = field.allowOtherOption && (editingOther || custom.length > 0);
  const sentinel = `__other_${inputId}`;
  const selected = field.allowMultiple
    ? [...answers.filter(answer => optionValues.includes(answer) || !field.allowOtherOption), ...(other ? [sentinel] : [])]
    : other ? sentinel : value || '';
  if (disabled) return <div className="form-list-readonly" aria-label={field.label}>{answers.join(', ') || '—'}</div>;
  const changeSelection = event => {
    const selection = field.allowMultiple ? Array.from(event.target.selectedOptions, option => option.value) : [event.target.value];
    const useOther = selection.includes(sentinel);
    setEditingOther(useOther);
    const next = selection.filter(answer => answer !== sentinel && answer !== '');
    if (useOther && draft.trim()) next.push(normalizeOtherOption(draft, field));
    onChange(field.allowMultiple ? next : next[0] || '');
  };
  const changeCustom = event => {
    const next = normalizeOtherOption(event.target.value, field);
    setDraft(next);
    const fixed = answers.filter(answer => optionValues.includes(answer));
    onChange(field.allowMultiple ? [...fixed, ...(next ? [next] : [])] : next);
  };
  return <div className="form-list-field">
    <select id={field.id} name={field.id} className={className} value={selected} multiple={field.allowMultiple}
      required={field.required && !other} onChange={changeSelection} aria-describedby={other ? `${inputId}-hint` : undefined}>
      {!field.allowMultiple && <option value="" disabled>Selecione...</option>}
      {optionValues.map((option, index) => <option key={`${index}-${option}`} value={option}>{option}</option>)}
      {field.allowOtherOption && <option value={sentinel}>{otherOptionLabel(field)}</option>}
      {!field.allowOtherOption && custom.map(option => <option key={option} value={option}>{option}</option>)}
    </select>
    {other && <div className="form-list-other">
      <label htmlFor={`${inputId}-text`}>{otherOptionLabel(field)} <span aria-hidden="true">*</span></label>
      <input id={`${inputId}-text`} className={className} value={draft} onChange={changeCustom} required pattern=".*\S.*"
        aria-label={`${field.label}: ${otherOptionLabel(field)}`} aria-describedby={`${inputId}-hint`}
        inputMode={field.otherOptionInput === 'numbers' ? 'numeric' : 'text'} placeholder="Digite sua resposta" />
      <p id={`${inputId}-hint`}>Informe uma resposta diferente das opções da lista.</p>
    </div>}
  </div>;
}
